import type { SxProps } from '@coolblue-development/freddy';
import { freddyTheme } from '@coolblue-development/freddy';

export const onlyShowDifferencesSwitchStyles: SxProps = {
  label: {
    position: 'sticky',
    left: 0
  },
  // This selector hides details when all values are the same.
  // The commented block below is kept for documentation purposes.
  /*
      details:not(
        :has(
          .property-row:not(.all-values-are-same)
        )
      )
    */
  '&.checked + div': {
    '.all-values-are-same, details:not(:has(.property-row:not(.all-values-are-same)))': {
      display: 'none'
    }
  },

  [freddyTheme.breakpoint.maxWidth('lg')]: {
    marginTop: freddyTheme.spacing[400]
  }
};
